import { Link } from "react-router-dom";

// One connected bar. Five numbers. Each one opens the filtered list behind it.
export function ActiveWork({ active, className = "" }) {
  const segs = [
    ["quotes", "Quotes awaiting response", active.quotes_awaiting, "/deals/quotes?status=sent"],
    ["scheduled", "Scheduled", active.jobs_scheduled, "/jobs?status=scheduled"],
    ["progress", "In progress", active.jobs_in_progress, "/jobs?status=in_progress"],
    ["attention", "Requiring attention", active.jobs_attention, "/deals?view=attention", active.jobs_attention ? "warn" : ""],
    ["completed", "Completed this month", active.jobs_completed_month, "/jobs?status=completed"],
  ];
  return (
    <section className={className} data-testid="active-work">
      <div className="mb-2 flex items-baseline justify-between"><h2 className="h2 text-[15px]">Active work</h2><Link to="/jobs" className="t3 text-[12px] font-medium hover:underline" data-testid="active-work-all">All jobs →</Link></div>
      <div className="aw-bar">
        {segs.map(([key, label, n, to, tone]) => (
          <Link key={key} to={to} className={`aw-seg ${tone || ""}`} data-testid={`active-work-${key}`}>
            <span className="eyebrow block truncate !text-[10.5px]">{label}</span>
            <span className="val tnum">{n ?? 0}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
